module.exports = __webpack_public_path__ + "static/media/pond-blob-rectangle-2.1fe3999f.png";